<template>
	<div class="discountCoupon" ref="body">
			<div class="discountCoupon-centre">
				<div class="roll"></div>
				<div class="gold"></div>
				<div class="gold-30" :style="{ top: data.length > 2 ? '7.056667rem' : '5rem' }"></div>
				<div class="gold-50"></div>
				<div class="remove" @click="remove"></div>
				<p class="discountCoupon-title">恭喜获得{{ data.length }}张优惠券</p>
				<div class="content-box" >
					<div class="content" v-for="(item, index) in data" :key="item.id">
						<div class="content-left">
							<p class="content-left-money">
								<span>{{item.type==0? item.value : item.value/10}}</span>
								{{item.type==0?'￥' : '折'}}
							</p>
							<p class="content-left-text">{{item.useType==0?'无门槛使用' : `满${item.useConditionPrice}元使用` }}</p>
						</div>
						<div class="content-right">
							<h3>{{item.type==0?item.useType==0?'直减优惠券' : '满减优惠券':'满减折扣优惠券'}}</h3>
							<div>
								<div class="content-left-day">
									<p>开始时间 {{ item.useBeginDate.slice(0, 10) }}</p>
									<p>结束时间 {{ item.useEndDate.slice(0, 10) }}</p>
								</div>
								<div class="content-right-btn" @click="immediate(index)" ref="btn">立即领取</div>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>
<script>
export default {
	name: 'DiscountCoupon',
	data() {
		return {};
	},
	props: ['data'],
	methods: {
		//立即领取
		immediate(index) {
			let btn = this.$refs.btn[index];
			if (btn.innerHTML == '已领取') {
				return;
			}
			let params = {
				params: {
					couponTemplateId: this.data[index].couponTemplateId
				}
			};
			this.$axios
				.post('coupon/receive', params)
				.then(res => {
					this.$toast({
						message: '领取成功',
						duration: 1000
					});
					btn.innerHTML = '已领取';
					btn.style.background = '#ccc';
				})
				.catch(err => {
					this.$toast({
						message: err.data.msg,
						duration: 1000
					});
				});
		},
		// 隐藏优惠券
		remove() {
			this.$emit('favorable');
		}
	}
};
</script>

<style scoped>

.discountCoupon {
	margin: 0;
	padding: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	left: 0;
	top: 0;
}

.remove {
	position: absolute;
	top: 10rem;
	left: 50%;
	transform: translate(-50%);
	width: 0.8rem;
	height: 0.8rem;
	background: url('../../../assets/btn-rem@2x.png') no-repeat 0 0 / 100% 100%;
}

.discountCoupon-centre {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(20%);
	width: 8.53rem;
	margin-top: -50%;
	max-height: 9.21rem;
	min-height: 4.53rem;
	border-radius: 0.266667rem;
	z-index: 1;
	background: url('../../../assets/honbaodi@2x.png') no-repeat 0 0 /100% 100%;
	padding-bottom: 1rem;
}

.roll,
.gold,
.gold-30,
.gold-50,
.bottom,
.border-acr {
	position: absolute;
	left: 50%;
	transform: translate(-50%);
}

.roll {
	width: 8rem;
	height: 5rem;
	top: 1rem;
	background: url('../../../assets/rool@2x.png') no-repeat 0 0 / 100% 100%;
	top: -2.9rem;
	z-index: 2;
}

.bottom {
	width: 8.53rem;
	height: 1.45rem;
	top: 11.5rem;
	background: url('../../../assets/honbao@2x.png') no-repeat 0 0 / 100% 100%;
	z-index: 4;
}

.bottom-btn {
	width: 4.27rem;
	height: 0.96rem;
	background: rgba(255, 235, 63, 1);
	border-radius: 0.5rem;
	margin: 1.6rem auto;
	text-align: center;
	line-height: 1rem;
	font-size: 0.48rem;
	font-family: PingFang-SC-Bold;
	font-weight: bold;
	color: rgba(146, 109, 9, 1);
}

.discountCoupon-title {
	width: 100%;
	height: 1.61rem;
	line-height: 1.61rem;
	font-size: 0.6rem;
	font-family: PingFang-SC-Heavy;
	font-weight: 800;
	color: rgba(251, 252, 126, 1);
	text-align: center;
}

.content {
	box-sizing: border-box;
	width: 100%;
	height: 1.866667rem;
	margin: auto;
	background-color: white;
	margin-top: 0.1rem;
	background: url('../../../assets/yhq@2x.png') no-repeat 0 0 / 100% 100%;
	padding: 0.133333rem 0 0.133333rem 0.133333rem;
	text-align: center;
}

.content-box {
	width: 88%;
	max-height: 5.3rem;
	margin: auto;
	background-color: white;
	overflow-y: scroll;
	background: transparent;
	margin-bottom: .5rem;
}

.content > div {
	float: left;
}

.content-left {
	width: 29%;
	height: 100%;
}

.content-left-money {
	height: 1rem;
	color: #d13f26;
}

.content-left-money > span {
	font-size: 0.9rem;
}

.content-left-text {
	color: #8f8f8f;
	padding-top: 0.133333rem;
}

.content-right {
	width: 69%;
	padding-left: 2%;
}

.content-right > h3 {
	width: 100%;
	height: 0.41rem;
	font-size: 0.43rem;
	font-family: PingFang-SC-Bold;
	font-weight: bold;
	text-align: left;
	color: rgba(46, 46, 46, 1);
}

.content-right > div {
	overflow: hidden;
	margin-top: 0.266667rem;
}

.content-right > div > div {
	float: left;
}

.content-right > div p {
	font-size: 0.266667rem;
	font-family: PingFang-SC-Regular;
	font-weight: 400;
	color: rgba(143, 143, 143, 1);
}

.content-right .content-right-btn {
	float: right;
	width: 1.5rem;
	height: 0.57rem;
	background: rgba(209, 63, 38, 1);
	border-radius: 0.3rem;
	font-size: 0.266667rem;
	font-family: PingFang-SC-Medium;
	color: rgba(255, 255, 255, 1);
	line-height: 0.57rem;
	margin: 0.133333rem 0.266667rem 0 0;
}

.gold,
.gold-30,
.gold-50 {
	position: absolute;
	z-index: 5;
}

.gold {
	width: 1.4rem;
	height: 1rem;
	background: url('../../../assets/many@2x.png') no-repeat 0 0 / 100% 100%;
	top: 1.333333rem;
	margin-left: 4rem;
}

.gold-30 {
	width: 1rem;
	height: 0.7rem;
	background: url('../../../assets/many-30@2x.png') no-repeat 0 0 / 100% 100%;
	top: 4.056667rem;
	margin-left: 2.666667rem;
}

.gold-50 {
	width: 1.7rem;
	height: 1rem;
	background: url('../../../assets/many-50@2x.png') no-repeat 0 0 / 100% 100%;
	top: 3.2rem;
	margin-left: -4rem;
}

.h-content {
	width: 100%;
	height: 20px;
}
</style>
